import React from 'react';
import '../../styles/wave-header.css';

const WaveHeader = ({ children }) => {
  return (
    <div className="notch-header-container">
      <div className="notch-header-content">
        {children}
      </div>
      <div className="notch-shape"></div>
    </div>
  );
};

export default WaveHeader;
